(function () {
  var SIGENERGY_ARTICLE_URL = 'https://photovoltaik-berg.de/blogs/ratgeber/sigenergy-unter-der-lupe-wechselrichter-speicher-erfahrungen-preis';
  var SIGENERGY_ARTICLE_TITLE = 'Sigenergy unter der Lupe: Wechselrichter, Speicher Erfahrungen & Preis';

  function readStorage(storage, key) {
    try {
      return storage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function normalizeSigenergyConfig(rawConfig) {
    if (!rawConfig) return '';
    var text = String(rawConfig).trim();
    if (!text) return '';
    if (text.indexOf('Ich möchte folgendes Sigenergy-System anfragen') !== -1) {
      return text;
    }

    var fields = {};
    text.split('|').forEach(function (part) {
      var index = part.indexOf(':');
      if (index === -1) return;
      var key = part.slice(0, index).trim();
      var value = part.slice(index + 1).trim();
      if (key && value) fields[key] = value;
    });

    var lines = [
      'Hallo, ich habe Ihren Blogartikel "' + SIGENERGY_ARTICLE_TITLE + '" gelesen:',
      SIGENERGY_ARTICLE_URL,
      '',
      'Ich möchte folgendes Sigenergy-System anfragen:'
    ];

    [
      'PV-Leistung',
      'Speichergröße',
      'System',
      'Wallbox',
      'Ersatzstrom/Gateway',
      'Wärmepumpe',
      'Elektroinstallation',
      'Konfigurierter Preis'
    ].forEach(function (key) {
      if (fields[key]) lines.push('- ' + key + ': ' + fields[key]);
    });

    lines.push('', 'Bitte prüfen Sie diese Konfiguration unverbindlich.');
    return lines.join('\n');
  }

  function setFieldValue(field, value) {
    if (!field || !value) return;
    var descriptor = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value');
    if (descriptor && descriptor.set) {
      descriptor.set.call(field, value);
    } else {
      field.value = value;
    }
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getConfigText() {
    var params = new URLSearchParams(window.location.search);
    return normalizeSigenergyConfig(params.get('sigenergy_config')) ||
      params.get('pv_config') ||
      params.get('message') ||
      readStorage(window.sessionStorage, 'pvCalculatorConfig') ||
      readStorage(window.localStorage, 'pvCalculatorConfig');
  }

  // URL payload is authoritative; stored configurations and async form restoration
  // must not replace it. Trusted edits are preserved for the rest of this visit.
  function prefillCurrentSigenergy() {
    var configText = new URLSearchParams(window.location.search).get('pv_config') || '';
    if (!/^Ich möchte diese (?:Sigenergy|Hoymiles|Tesla)-Komplettanlage anfragen:/.test(configText)) return false;
    if (!/\/pages\/contact\/?$/.test(window.location.pathname)) return true;
    var selector = '[id="36872-textarea"], .globo-form-id-36872 textarea[name="textarea"], .globo-form-id-36872 textarea[data-type="textarea"], .globo-form-app[data-id="36872"] textarea, #ContactForm-body';
    var touched = false;
    function onInput(event) {
      if (event.isTrusted && event.target.matches(selector)) touched = true;
    }
    document.addEventListener('input', onInput, true);
    function fill() {
      if (touched) return;
      document.querySelectorAll(selector).forEach(function (field) {
        if (field.value !== configText) setFieldValue(field, configText);
      });
    }
    // Refresh legacy fallbacks as well, including on a direct shared inquiry URL.
    ['sessionStorage', 'localStorage'].forEach(function (name) {
      try { window[name].setItem('pvCalculatorConfig', configText); } catch (error) {}
    });
    fill();
    var timer = window.setInterval(fill, 250);
    var observer = new MutationObserver(fill);
    observer.observe(document.documentElement, {childList: true, subtree: true});
    window.addEventListener('pageshow', fill);
    window.setTimeout(function () {
      window.clearInterval(timer);
      observer.disconnect();
      fill();
    }, 30000);
    return true;
  }

  function prefillContactForm() {
    if (prefillCurrentSigenergy()) return;
    var configText = getConfigText();
    if (!configText) return;

    var targetSelector = [
      '[id="36872-textarea"]',
      '.globo-form-id-36872 textarea[name="textarea"]',
      '.globo-form-id-36872 textarea[data-type="textarea"]',
      '.globo-form-app[data-id="36872"] textarea',
      '#ContactForm-body'
    ].join(',');

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      var field = document.querySelector(targetSelector);
      if (field) {
        setFieldValue(field, configText);
        window.clearInterval(timer);
      }
      if (attempts >= 40) window.clearInterval(timer);
    }, 250);
  }

  function normalizeSigenergyArticleLinks() {
    if (window.location.pathname.indexOf('/blogs/ratgeber/sigenergy-unter-der-lupe-wechselrichter-speicher-erfahrungen-preis') === -1) {
      return;
    }

    document.querySelectorAll('a[href="/pages/kontakt"], a[href^="/pages/kontakt?"]').forEach(function (link) {
      link.href = link.href.replace('/pages/kontakt', '/pages/contact');
    });
  }

  function ensureSigenergyProjectGallery() {
    // Native article blocks are maintained in the theme editor, not by legacy HTML hotfixes.
    if (document.querySelector('[data-pvb-ratgeber]')) return;
    if (window.location.pathname.indexOf('/blogs/ratgeber/sigenergy-unter-der-lupe-wechselrichter-speicher-erfahrungen-preis') === -1) {
      return;
    }

    var section = document.querySelector('.pv-dc-ac-slider--article');
    if (!section || section.textContent.indexOf('22457 Hamburg') !== -1) return;

    var latestCss = 'https://cdn.shopify.com/s/files/1/0768/2601/8125/t/1/assets/section-pv-dc-ac-slider.css?v=1782890916';
    if (!document.querySelector('link[href="' + latestCss + '"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = latestCss;
      document.head.appendChild(link);
    }

    function ensureSliderScript() {
      var latestScript = 'https://cdn.shopify.com/s/files/1/0768/2601/8125/t/1/assets/pv-dc-ac-slider.js?v=1782888424';
      if (window.PVDCACSliderInit) {
        window.PVDCACSliderInit(section);
        return;
      }
      if (document.querySelector('script[src="' + latestScript + '"]')) return;
      var script = document.createElement('script');
      script.src = latestScript;
      script.defer = true;
      script.addEventListener('load', function () {
        if (window.PVDCACSliderInit) window.PVDCACSliderInit(section);
      });
      document.body.appendChild(script);
    }

    var img50859Dc = 'https://cdn.shopify.com/s/files/1/0768/2601/8125/t/1/assets/sigenergy-projekt-50859-dc-dachanlage-slider.jpg?v=1782888712';
    var img50859Ac = 'https://cdn.shopify.com/s/files/1/0768/2601/8125/t/1/assets/sigenergy-projekt-50859-ac-installation-slider.jpg?v=1782888713';
    var img49610Dc = 'https://cdn.shopify.com/s/files/1/0768/2601/8125/t/1/assets/sigenergy-projekt-49610-dc-dachanlage-slider.jpg?v=1782888715';
    var img49610Ac = 'https://cdn.shopify.com/s/files/1/0768/2601/8125/t/1/assets/sigenergy-projekt-49610-ac-installation-slider.jpg?v=1782888716';
    var img48429Dc = 'https://cdn.shopify.com/s/files/1/0768/2601/8125/t/1/assets/sigenergy-projekt-48429-dc-dachanlage-slider.jpg?v=1782889286';
    var img48429Ac = 'https://cdn.shopify.com/s/files/1/0768/2601/8125/t/1/assets/sigenergy-projekt-48429-ac-installation-slider.jpg?v=1782889288';
    var img76297Dc = 'https://cdn.shopify.com/s/files/1/0768/2601/8125/t/1/assets/sigenergy-projekt-76297-dc-dachanlage-slider.jpg?v=1782889717';
    var img76297Ac = 'https://cdn.shopify.com/s/files/1/0768/2601/8125/t/1/assets/sigenergy-projekt-76297-ac-installation-slider.jpg?v=1782889718';
    var img28844Dc = 'https://cdn.shopify.com/s/files/1/0768/2601/8125/t/1/assets/sigenergy-projekt-28844-dc-dachanlage-slider.jpg?v=1782890435';
    var img28844Ac = 'https://cdn.shopify.com/s/files/1/0768/2601/8125/t/1/assets/sigenergy-projekt-28844-ac-installation-slider.jpg?v=1782890436';
    var img22457Dc = 'https://cdn.shopify.com/s/files/1/0768/2601/8125/t/1/assets/sigenergy-projekt-22457-dc-dachanlage-slider.jpg?v=1782891317';
    var img22457Ac = 'https://cdn.shopify.com/s/files/1/0768/2601/8125/t/1/assets/sigenergy-projekt-22457-ac-installation-slider.jpg?v=1782891319';

    function stage(id, position, aria, acSrc, acAlt, dcSrc, dcAlt) {
      return [
        '<div id="' + id + '" class="pv-dc-ac-slider__stage" data-pv-dc-ac-slider data-position="' + position + '" style="--pv-dc-ac-position:' + position + '%; --pv-dc-ac-aspect:100%;" aria-label="' + aria + '">',
        '<img class="pv-dc-ac-slider__image pv-dc-ac-slider__image--ac" src="' + acSrc + '" alt="' + acAlt + '" loading="lazy" width="1600" height="1600">',
        '<img class="pv-dc-ac-slider__image pv-dc-ac-slider__image--dc" src="' + dcSrc + '" alt="' + dcAlt + '" loading="lazy" width="1600" height="1600">',
        '<span class="pv-dc-ac-slider__label pv-dc-ac-slider__label--dc">Dachmontage</span>',
        '<span class="pv-dc-ac-slider__label pv-dc-ac-slider__label--ac">Elektromontage</span>',
        '<span class="pv-dc-ac-slider__divider" aria-hidden="true"></span>',
        '<span class="pv-dc-ac-slider__handle" aria-hidden="true"></span>',
        '<input class="pv-dc-ac-slider__range" data-pv-dc-ac-range type="range" min="0" max="100" step="1" value="' + position + '" aria-label="Dachmontage und Elektromontage vergleichen">',
        '</div>'
      ].join('');
    }

    section.setAttribute('aria-labelledby', 'sigenergy-projekte');
    section.style.setProperty('--pv-dc-ac-aspect', '100%');
    section.innerHTML = [
      '<div class="pv-dc-ac-slider__inner" data-pv-dc-ac-gallery>',
      '<div class="pv-dc-ac-slider__header"><h2 id="sigenergy-projekte" class="pv-dc-ac-slider__heading h2">Echte Sigenergy Projekte</h2></div>',
      '<div class="pv-dc-ac-slider__project-nav" aria-label="Projekt wechseln">',
      '<button class="pv-dc-ac-slider__project-button" type="button" data-pv-dc-ac-prev aria-label="Vorheriges Projekt">‹</button>',
      '<span class="pv-dc-ac-slider__project-count" data-pv-dc-ac-count>1 / 6</span>',
      '<button class="pv-dc-ac-slider__project-button" type="button" data-pv-dc-ac-next aria-label="Nächstes Projekt">›</button>',
      '</div>',
      '<div class="pv-dc-ac-slider__projects">',
      '<article class="pv-dc-ac-slider__project is-active" data-pv-dc-ac-project data-project-index="0">',
      stage('PVDCACSlider-sigenergy-50859', 58, "Vergleich zwischen Dachmontage und Elektromontage der Sigenergy-Anlage in 50859 Köln", img50859Ac, "Sigenergy AC-Installation mit Speicher, Wechselrichter und Elektroverteilung in einem Technikraum", img50859Dc, "Photovoltaik-Dachanlage mit neu installierten Modulen auf einem Wohnhaus in Köln"),
      '<div class="pv-dc-ac-slider__project-copy"><h3 class="pv-dc-ac-slider__project-title">50859 Köln · Sigenergy</h3><div class="pv-dc-ac-slider__project-description rte"><p>Sigenergy Installation in 50859 Köln: 43 JA-Solar-Module à 450 W mit 19,35 kWp Gesamtleistung.</p><p>AC-seitig: Sigenergy TP2 12 kW + 8 kW, 3 × 9 kWh SigenStor-Speicher, Notstrom ja, Wallbox nein.</p></div></div>',
      '</article>',
      '<article class="pv-dc-ac-slider__project" data-pv-dc-ac-project data-project-index="1">',
      stage('PVDCACSlider-sigenergy-49610', 58, "Vergleich zwischen Dachmontage und Elektromontage der Sigenergy-Anlage in 49610 Quakenbrück", img49610Ac, "Sigenergy AC-Installation mit Energy Controller und SigenStor-Speicher in einer Garage", img49610Dc, "Photovoltaik-Dachanlage mit Aiko-Modulen auf einem Wohnhaus in Quakenbrück"),
      '<div class="pv-dc-ac-slider__project-copy"><h3 class="pv-dc-ac-slider__project-title">49610 Quakenbrück · Sigenergy</h3><div class="pv-dc-ac-slider__project-description rte"><p>Sigenergy Installation in 49610 Quakenbrück: 24 Aiko-Neostar-3-S-Module à 475 W mit 11,4 kWp Gesamtleistung.</p><p>AC-seitig: Sigenergy Energy Controller TP12, 9 + 6 kWh SigenStor-Speicher, Sigen Gateway HomePro TP, Wallbox nein.</p></div></div>',
      '</article>',
      '<article class="pv-dc-ac-slider__project" data-pv-dc-ac-project data-project-index="2">',
      stage('PVDCACSlider-sigenergy-48429', 58, "Vergleich zwischen Dachmontage und Elektromontage der Sigenergy-Anlage in 48429 Rheine", img48429Ac, "Sigenergy AC-Installation mit Hybrid-Wechselrichter, SigenStor-Speicher und Zählerschrank in Rheine", img48429Dc, "Photovoltaik-Dachanlage mit JA-Solar-Modulen auf einem Wohnhaus in Rheine"),
      '<div class="pv-dc-ac-slider__project-copy"><h3 class="pv-dc-ac-slider__project-title">48429 Rheine · Sigenergy</h3><div class="pv-dc-ac-slider__project-description rte"><p>Sigenergy Installation in 48429 Rheine: 21 JA-Solar-Module à 450 W mit 9,45 kWp Gesamtleistung.</p><p>AC-seitig: Sigenergy TP2 Hybrid 10 kW, 9 + 6 kWh SigenStor-Speicher, Notstrom nein, Wallbox ja.</p></div></div>',
      '</article>',
      '<article class="pv-dc-ac-slider__project" data-pv-dc-ac-project data-project-index="3">',
      stage('PVDCACSlider-sigenergy-76297', 58, "Vergleich zwischen Dachmontage und Elektromontage der Sigenergy-Anlage in 76297 Stutensee", img76297Ac, "Sigenergy AC-Installation mit Hybrid-Wechselrichter und SigenStor-Speicher in Stutensee", img76297Dc, "Photovoltaik-Dachanlage mit JA-Solar-Modulen auf einem Wohnhaus in Stutensee"),
      '<div class="pv-dc-ac-slider__project-copy"><h3 class="pv-dc-ac-slider__project-title">76297 Stutensee · Sigenergy</h3><div class="pv-dc-ac-slider__project-description rte"><p>Sigenergy Installation in 76297 Stutensee: 20 JA-Solar-Module à 450 W mit 9,0 kWp Gesamtleistung.</p><p>AC-seitig: Sigenergy TP2 Hybrid 8 kW, 9 kWh SigenStor-Speicher, Notstrom nein, Wallbox nein.</p></div></div>',
      '</article>',
      '<article class="pv-dc-ac-slider__project" data-pv-dc-ac-project data-project-index="4">',
      stage('PVDCACSlider-sigenergy-28844', 58, "Vergleich zwischen Dachmontage und Elektromontage der Sigenergy-Anlage in 28844 Weyhe", img28844Ac, "Sigenergy SigenStor-Speicher in einem Technikraum in Weyhe", img28844Dc, "Photovoltaik-Dachanlage mit AIKO-Modulen auf einem Wohnhaus in Weyhe"),
      '<div class="pv-dc-ac-slider__project-copy"><h3 class="pv-dc-ac-slider__project-title">28844 Weyhe · Sigenergy</h3><div class="pv-dc-ac-slider__project-description rte"><p>Sigenergy Installation in 28844 Weyhe: 30 AIKO-Neostar-3S+-Module à 475 W mit 14,25 kWp Gesamtleistung.</p><p>AC-seitig: Sigenergy Energy Controller 12.0 TP, 15 kWh SigenStor-Speicher, Notstrom nein, Wallbox nein.</p></div></div>',
      '</article>',
      '<article class="pv-dc-ac-slider__project" data-pv-dc-ac-project data-project-index="5">',
      stage('PVDCACSlider-sigenergy-22457', 58, "Vergleich zwischen Dachmontage und Elektromontage der Sigenergy-Anlage in 22457 Hamburg", img22457Ac, "Sigenergy SigenStor-Speicher im Außenbereich in Hamburg", img22457Dc, "Photovoltaik-Dachanlage mit JA-Solar-Modulen auf einem Wohnhaus in Hamburg"),
      '<div class="pv-dc-ac-slider__project-copy"><h3 class="pv-dc-ac-slider__project-title">22457 Hamburg · Sigenergy</h3><div class="pv-dc-ac-slider__project-description rte"><p>Sigenergy Installation in 22457 Hamburg: 18 JA-Solar-Module à 450 W mit 8,1 kWp Gesamtleistung.</p><p>AC-seitig: Sigenergy TP 12 kW, 9 + 6 kWh SigenStor-Speicher, Notstrom nein, DC-Charger-Wallbox ja.</p></div></div>',
      '</article>',
      '</div>',
      '</div>'
    ].join('');
    ensureSliderScript();
  }


  function init() {
    normalizeSigenergyArticleLinks();
    ensureSigenergyProjectGallery();
    prefillContactForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
